import iro from '@jaames/iro';

export function mixHex(color1: string, color2: string, weight = 0.5): string | null {
	if (!color1 || !color2)
		return null;

	const iroColor1 = new iro.Color(color1);
	const iroColor2 = new iro.Color(color2);

	const r = Math.round(iroColor1.red * weight + iroColor2.red * (1 - weight));
	const g = Math.round(iroColor1.green * weight + iroColor2.green * (1 - weight));
	const b = Math.round(iroColor1.blue * weight + iroColor2.blue * (1 - weight));

	const mixedColor = new iro.Color({ r, g, b });
	return mixedColor.hexString;
}

export function darkenHex(color: string) : string | null {
	const iroColor = new iro.Color(color);
	const hsl = iroColor.hsl;
	hsl.l = Math.max(0, hsl.l - 1);

	if (hsl.l === 0)
		return '#000000';
	iroColor.hsl = hsl;
	return iroColor.hexString;
}

export function lightenHex(color: string) : string | null {
	const iroColor = new iro.Color(color);
	const hsl = iroColor.hsl;
	hsl.l = Math.min(100, hsl.l + 1);

	if (hsl.l === 100)
		return '#ffffff';
	iroColor.hsl = hsl;
	return iroColor.hexString;
}
